<template>
  <section class="container">
    <input type="hidden" ref="mobile" name="mobile" class="ls-display-none-sm ls-display-none-md ls-display-none-lg ls-display-block-xs">
    <ol class="progress ls-lg-margin-bottom ls-display-none-sm ls-display-none-md ls-display-none-lg">
      <li :class="[forms.submitted.signup ? 'is-complete' : 'is-active']" @click="backToSignatureForm"><span class="icon-circle"><i aria-hidden="true" class="fa" :class="[forms.submitted.signup ? 'fa-check' : 'fa-user-o']"></i></span>{{ $t('subscribe.titles.identify') }}</li>
      <li class="progress__last" :class="{ 'is-active' : forms.submitted.signup && forms.submitted.address }"><span class="icon-circle"><i aria-hidden="true" class="fa fa-credit-card"></i></span>{{ $t('subscribe.titles.payment_review') }}</li>
    </ol>
    <flash-message></flash-message>
    <div class="row">
      <div class="col-md-8 col-sm-6 ls-md-margin-bottom">
        <login-form v-show="forms.login"></login-form>
        <email-form v-show="forms.email"></email-form>
        <signup-form v-show="forms.signup"></signup-form>
      </div>
      <div class="col-xs-12 col-md-4 col-sm-6">
        <box-checkout></box-checkout>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import MaterialInput from '../../components/shareds/MaterialInput.vue'
  import BoxCheckout from './components/BoxCheckout.vue'
  import EmailForm from './components/EmailForm.vue'
  import LoginForm from './components/LoginForm.vue'
  import SignupForm from './components/SignupForm.vue'
  import money from 'src/utils/money'
  import * as location from 'src/utils/location'
  import * as format from 'src/utils/form'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'Checkout',
    components: { BoxCheckout, MaterialInput, SignupForm, EmailForm, LoginForm },
    data () {
      return {
        onlyNumber: /[\D]/g,
        money: money,
        validField: true,
        forms: {
          email: true,
          login: false,
          signup: false,
          payment: false,
          submitted: {
            signup: false,
            payment: false
          },
          force: {
            address: false
          }
        },
        id: null,
        password: '',
        name: '',
        email: '',
        kind: 'P',
        cpf: '',
        cnpj: '',
        company_name: '',
        tradeName: '',
        contactId: null,
        fullPhone: '',
        addressId: null,
        postalCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: ''
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'chosenPlan', 'contract', 'basicSeller', 'seller', 'currentUser'])
    },
    methods: {
      ...mapActions(['attemptLogin', 'loadPlan']),
      ...mapMutations(['clearFlash']),
      backToEmailForm () {
        this.$loader.show()

        this.clearFlash()
        this.clearCustomer()
        this.resetForms()
        this.password = ''

        this.forms.email = true
        this.forms.login = false
        this.forms.signup = false
        this.forms.payment = false

        window.localStorage.removeItem('customer')
        window.localStorage.removeItem('customerToken')

        setTimeout(this.$loader.hide, 500)
      },
      isAuthenticated () {
        const sessionTime = 15
        if (window.localStorage.customer) {
          let customer = JSON.parse(window.localStorage.customer)
          let loggedTime = new Date().getTime() - customer.access_time
          let minutesLogged = new Date(loggedTime).getMinutes()
          if (minutesLogged > sessionTime) {
            window.localStorage.removeItem('customer')
            window.localStorage.removeItem('customerToken')
          }
        }
      },
      backToSignatureForm () {
        this.$loader.show()
        this.forms.submitted.signup = false
        this.forms.signup = true

        setTimeout(this.$loader.hide, 500)
      },
      backToAddressForm () {
        this.$loader.show()
        this.forms.payment = false

        setTimeout(this.$loader.hide, 500)
      },
      backToSignaturePlans () {
        this.$loader.show()

        this.$parent.checkout = false
        this.$parent.choosePlan = true

        setTimeout(this.$loader.hide, 500)
      },
      getUsernameFromUrl: function () {
        return location.getUsername()
      },
      messageValid (response) {
        if (response && response.status === 200) {
          this.validField = true
        } else {
          this.validField = false
          return this.$validator.validate('customer.email', this.validField)
        }
      },
      formatCep (cep) {
        let regex = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/
        return cep.replace(regex, '$1.$2-$3')
      },
      loadCustomer () {
        this.$loader.show()
        this.setCustomerCheckout(JSON.parse(window.localStorage.customer)).then(() => {
          this.forms.login = false
          this.forms.email = false
          this.forms.signup = true
        })
      },
      async setCustomerCheckout (customer) {
        this.id = customer.id
        this.name = customer.name
        this.email = customer.email
        if (customer.cpf) this.cpf = format.cpf(customer.cpf)
        this.kind = customer.kind
        this.company_name = customer.company_name
        this.tradeName = customer.trade_name
        if (customer.cnpj) this.cnpj = format.cnpj(customer.cnpj)
        if (customer.contact != null) {
          this.contactId = customer.contact.id
          this.fullPhone = format.formatPhone(customer.contact.area_code + customer.contact.number)
        }
        if (customer.address != null) {
          this.addressId = customer.address.id
          this.postalCode = this.formatCep(customer.address.postal_code)
          this.street = customer.address.street
          if (customer.address.number) this.number = parseInt(customer.address.number)
          this.complement = customer.address.complement
          this.neighborhood = customer.address.neighborhood
          this.city = customer.address.city
          this.state = customer.address.state
        }
      },
      clearCustomer () {
        this.id = null
        this.password = ''
        this.name = ''
        this.email = ''
        this.kind = 'P'
        this.cpf = ''
        this.cnpj = ''
        this.tradeName = ''
        this.companyName = ''
        this.contactId = null
        this.fullPhone = ''
        this.addressId = null
        this.postalCode = ''
        this.street = ''
        this.number = ''
        this.complement = ''
        this.neighborhood = ''
        this.city = ''
        this.state = ''
      },
      resetForms () {
        this.forms.email = true
        this.forms.login = false
        this.forms.signup = false
        this.forms.payment = false
        this.forms.submitted.signup = false
        this.forms.submitted.payment = false
        this.forms.force.address = false
      }
    },
    mounted () {
      this.isAuthenticated()
      if (window.localStorage.customer) {
        this.loadCustomer()
      } else {
        scroll.scrollToFlash()
        this.clearCustomer()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .step-name {
    display: block;
    font-size: 12px;
  }
  .ls-custom-select {
    border-left: 0;
    border-left-radius: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    .ls-select {
      border: none;
    }
  }
  .ls-box {
    @media screen and (max-width: 768px) {
      border: none;
      border-radius: 0;
      padding: 0;
    }
  }
  .fields {
    -webkit-animation: anim 0.8s ease-out;
    -moz-animation: anim 0.8s ease-out;
    -o-animation: anim 0.8s ease-out;
    animation: anim 0.8s ease-out;
  }
  $complete: #2ECC71;
  $active: #3498DB;
  $mute: #DFE3E4;
  $size: 3em;

  .progress {
    display: flex;
    width: 100%;

    > li {
      -webkit-box-flex: 1;
      -ms-flex: 1 1 0%;
      flex: 1 1 0%;
      margin: 0;
      padding: 0;
      min-width: 28px;
      position: relative;
      display: block;
      text-align: center;
      font-size: 0.9em;

      .icon-circle {
        display: block;
        margin: 0 auto;
        background: $mute;
        width: $size;
        height: $size;
        text-align: center; //IE8 doesn't inherit this style
        margin-bottom: 0.25em;
        line-height: $size;
        border-radius: 100%;
        transition: all .3s ease-in-out;
        i {
          font-size: $size/2;
          transition: all .1s ease-in-out;
          &.fa.fa-check {
            color: #fff;
            transform: scale(1.3);
          }
        }
      }
      &:after {
        content: '';
        position: absolute;
        display: block;
        background: #DFE3E4;
        width: 100%;
        height: 0.3em;
        top: 1.4em;
        left: 50%;
        margin-left: 1.5em\9;
        z-index: -1;
        transition: all .3s ease-in-out;
      }
      &:last-child:after {
        display: none;
      }
      &.is-complete {
        color: $complete;

        &:before, &:after {
          color: #FFF;
          background: $complete;
        }
        .icon-circle {
          transform: scale(0.8);
          background: $complete;
        }
      }
      &.is-active {
        color: $active;

        &:before {
          color: #FFF;
          background: $active;
        }
        .icon-circle {
          background: $active;
          i {
            color: #fff;
          }
        }
      }
    }
  }
  /**
     * Needed for IE8
     */
  .progress__last:after {
    display: none !important;
  }

</style>



// WEBPACK FOOTER //
// Checkout.vue?35651a09